import { render, staticRenderFns } from "./ChiselDetail.vue?vue&type=template&id=01ca7536&scoped=true&"
import script from "./ChiselDetail.vue?vue&type=script&lang=js&"
export * from "./ChiselDetail.vue?vue&type=script&lang=js&"
import style0 from "./ChiselDetail.vue?vue&type=style&index=0&id=01ca7536&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ca7536",
  null
  
)

export default component.exports